import React, { useContext } from 'react';
import noop from 'lodash/noop';
export var UserContext = React.createContext({
  // This context value should be never used, always overridden in a provider.
  navigation: {
    expanded: false
  },
  setSidebarExpanded: noop
}); // UserContext helpers

export function useUserContext() {
  return useContext(UserContext);
}